<template>
    <section class="section">
        <div class="container">
            <div class="columns is-centered">
                <div class="column is-half">
                    <div class="field has-addons">
                        <div class="control">
                            <input v-model.trim="code"
                                   data-vv-name="confirmation code"
                                   data-vv-validate-on="change"
                                   v-validate="'required|digits:4'"
                                   :placeholder="'components.pages.registration.confirmation code' | translate"
                                   class="input is-large"
                                   maxlength="4"
                                   typeof="text"
                                   @input="errors.clear('serverErrors');"
                                   ref="code" />
                            <p class="help is-danger" v-if="errors.has('confirmation code:required') || errors.has('confirmation code:digits') || errors.has('confirmation code', 'serverErrors')">
                                {{"components.pages.registration.validation.confirmation code error" | translate}}
                            </p>
                        </div>
                        <div class="control">
                            <a class="button is-static is-large">{{countdown}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import utils from "../../../../../../_common/utils";

    export default {
        name: "email-confirmation",
        inject: ["$validator"],
        props: {
            value: { type: String, required: false }
        },
        data: () => ({
            code: null,
            loading: false,
            timeoutStart: new Date(),
            timeout: 15 * 60 * 1000, // 15 min
            countdown: null,
            countdownTimer: null,
            confirmationCodeError: null
        }),
        watch: {
            code: function(value) {
                this.$emit("update:value", value);
            }
        },
        mounted() {
            this.$refs.code.focus();
            this.startCountdown();
        },
        methods: {
            startCountdown() {
                this.countdownTimer && clearInterval(this.countdownTimer);
                this.timeoutStart = new Date();
                this.setCountdown();
                this.countdownTimer = setInterval(() => this.setCountdown(), 1000);
            },
            setCountdown() {
                let diff = this.timeoutStart.valueOf() - new Date().valueOf() + 15 * 60 * 1000;
                diff = Math.max(diff, 0);
                this.countdown = utils.formatDateTime(diff, 'mm:ss');
            },
            resetFields() {
                this.code = null;
            }
        },
        beforeDestroy() {
            this.resetFields();
            this.countdownTimer && clearInterval(this.countdownTimer);
        }
    };
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/login/email-confirmation.vue